// extracted by mini-css-extract-plugin
module.exports = {"card-content-white":"SGSCardContent_card-content-white__3MjaK","card-content-dark":"SGSCardContent_card-content-dark__23qxE"};